module.exports = __webpack_public_path__ + "static/media/koica_1.581458af.png";